export const distanceTimeFields = [
  {
    key: 'status',
    label: '',
    thClass: 'd-none',
  },
  {
    label: 'global.object.licensePlate',
    key: 'licensePlate',
    thClass: 'd-none',
  },
  {
    label: 'maintenance.field.compName',
    key: 'serviceComponent',
    thClass: 'd-none',
  },
  {
    label: 'global.activity',
    key: 'serviceActivity',
    thClass: 'd-none',
  },
  {
    label: 'maintenance.form.catService',
    key: 'serviceCategory',
    thClass: 'd-none',
  },
  {
    label: 'maintenance.field.firstServiceKm',
    key: 'startServiceAtDistance',
    thClass: 'd-none',
  },
  {
    label: 'maintenance.field.firstServiceDate',
    key: 'startServiceAtTime',
    thClass: 'd-none',
  },
  {
    label: 'maintenance.form.intKm',
    key: 'serviceIntervalDistance',
    thClass: 'd-none',
  },
  {
    label: 'maintenance.form.remindKm',
    key: 'serviceReminderDistance',
    thClass: 'd-none',
  },
  {
    label: 'master.form.driver.violationHis.score',
    key: 'serviceIntervalTime',
  },
  {
    label: 'global.object.period',
    key: 'serviceIntervalTimePeriod',
  },
  {
    label: 'master.form.driver.violationHis.score',
    key: 'serviceReminderTime',
  },
  {
    label: 'global.object.period',
    key: 'serviceReminderTimePeriod',
  },
  {
    label: 'maintenance.field.method',
    key: 'serviceMethod',
    thClass: 'd-none',
  },
]

export const hourmeterFields = [
  {
    key: 'status',
    label: '',
    thAttr: {
      style: 'min-width:40px;width:40px;',
    },
  },
  {
    label: 'global.object.licensePlate',
    key: 'licensePlate',
  },
  {
    label: 'maintenance.field.compName',
    key: 'serviceComponent',
  },
  {
    label: 'global.activity',
    key: 'serviceActivity',
  },
  {
    label: 'maintenance.form.catService',
    key: 'serviceCategory',
  },
  {
    label: 'maintenance.field.firstServiceHour',
    key: 'startServiceAtHourmeter',
  },
  {
    label: 'maintenance.field.hourmeterInterval',
    key: 'serviceIntervalHourmeter',
  },
  {
    label: 'maintenance.field.hourmeterIntervalReminder',
    key: 'serviceReminderHourmeter',
  },
  {
    label: 'maintenance.field.method',
    key: 'serviceMethod',
  },
]

export const refrigeratorFields = [
  {
    key: 'status',
    label: '',
    thAttr: {
      style: 'min-width:40px;width:40px;',
    },
  },
  {
    label: 'global.object.licensePlate',
    key: 'licensePlate',
  },
  {
    label: 'maintenance.field.compName',
    key: 'serviceComponent',
  },
  {
    label: 'global.activity',
    key: 'serviceActivity',
  },
  {
    label: 'maintenance.form.catService',
    key: 'serviceCategory',
  },
  {
    label: 'maintenance.field.firstServiceRefrigerator',
    key: 'startServiceAtRefrigerator',
  },
  {
    label: 'maintenance.field.refrigeratorInterval',
    key: 'serviceIntervalRefrigerator',
  },
  {
    label: 'maintenance.field.refrigeratorIntervalReminder',
    key: 'serviceReminderRefrigerator',
  },
  {
    label: 'maintenance.field.method',
    key: 'serviceMethod',
  },
]
